/**
 * Create a new journey artifact canvas
 * @returns {object} Journey artifact object
 */
export const createJourneyCanvas = () => {
  const emptyJourneyData = {
    nodes: [],
    links: [],
    texts: []
  };
  return {
    name: 'New Journey',
    description: 'Empty journey canvas - AI agent will build the journey step by step',
    content: JSON.stringify(emptyJourneyData, null, 2),
    journeyData: emptyJourneyData,
    language: 'json',
    filename: 'new_journey.json',
    id: 'journey-canvas-' + Date.now(),
    type: 'journey'
  };
};